 <template>
    <div class="tags_container">
      <p><b>Tags</b></p>
      <div>
        <input class="outlined full_width" placeholder="..." v-model="tagsValue" @change="updateApplicant">
      </div>
      <br />
      <div class="is-flex is-align-items-center is-flex-wrap-wrap">
        <span dir="ltr" v-for="(skill, idx) in featuredSkill" :key="'tag_' + idx">
          <ApplicantSkill v-if="!!skill.id" :applicant_id="payload.data.resource_id" :applicant_skill="skill" classBlue="true" @refresh="isRefreshed">
          </ApplicantSkill>
          <p v-else @click="toggleTag(skill)" class="skill button is-info applicant_skill is-outlined">{{ skill.text }}</p>
        </span>
      </div>
    </div>
</template>
<script>
// imports
import { mapMutations, mapGetters, mapActions } from 'vuex'

import ApplicantSkill from '@/components/ApplicantSkill'

export default {
  name: 'skills-tags-form',
  props: {
    payload: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      is_loading: false,
      mySetChangeTracker: 1,
      applicant: {},
      selected_tags: [],
      applicant_skills: []
    }
  },
  created () {
    this.init()
  },
  computed: {
    ...mapGetters('skills', ['dropdownFeaturedSkills']),
    featuredSkill () {
      return this.dropdownFeaturedSkills.map(skill => {
        return this.applicant_skills.find(s => s.skill.id.toString() == skill.value) || skill
      })
    },
    tagsValue: {
      get: function () {
        return this.mySetChangeTracker && [...this.selected_tags].join(', ')
      },
      set: function (newVal) {
        this.selected_tags = new Set(newVal.split(', '))
        this.$emit('new-value', newVal)
      }
    }
  },
  methods: {
    ...mapActions('skills', ['fetchAllSkills']),
    ...mapMutations('modals', ['remove']),
    init () {
      this.$network_utils.getUser(this.payload.data.id).then(response => {
        this.applicant = response
        this.selected_tags = new Set(!response.tags ? [] : response.tags.split(', '))
        this.$emit('new-value', response.tags)
      })
      this.fetchAllSkills()
      this.getApplicantSkills()
    },
    isRefreshed (payload) {
      if (payload.action != 'delete') return this.init()
      this.mySetChangeTracker += 1
      this.updateApplicant()
    },
    getApplicantSkills () {
      this.$network_utils.getApplicantSkills({ current_applicant_id: this.payload.data.resource_id }).then(response => {
        this.applicant_skills = response
      })
    },
    addApplicantSkill (id) {
      this.$network_utils.postApplicantSkill({ skill_id: id, current_applicant_id: this.payload.data.resource_id }).then(() => {
        this.updateApplicant()
      })
    },
    toggleTag ({ text, value }) {
      this.selected_tags.add(text)
      this.addApplicantSkill(value)
      this.mySetChangeTracker += 1
    },
    updateApplicant () {
      this.$network_utils.updateUser({ user_id: this.payload.data.id, tags: this.tagsValue }).then(() => {
        this.init()
      })
    }
  },
  components: {
    ApplicantSkill
  }
}
</script>
<style scoped>
  .tags_container a {
    margin-top: 10px;
    margin-right: 10px;
  }
  .applicant_skill{
    margin-left: 10px;
    margin-bottom: 10px;
    border: 1px solid #204d74;
    border-radius: 3px;
    padding: 3px 10px 3px 10px;
  }
</style>
